import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookie from 'js-cookie'
import customZH from './zh'
import customEN from './en'

Vue.use(VueI18n)

const locale = Cookie.get('userLanguage') === 'ru' ? 'en' : Cookie.get('userLanguage') || navigator.language.substring(0, 2) || navigator.userLanguage || 'en'

export default new VueI18n({
  locale,
  messages: {
    en: {
      ...customEN
    },
    zh: {
      ...customZH
    }
  },
  silentTranslationWarn: true
})
